import type {annotationStub, annotationUuid} from "../../main/data/model/index.js";
import Data from "../../main/data/index.js";
import Highlighter from "./index.js";
import {toast} from "../../lit-components/common/toast/toastControl.js";

class Bookmark {
	generateBookmarkStub = (): annotationStub => {
		return {
			version:  "2",
			type:     "bookmark",
			pageData: Highlighter.page.getPageData.bind(Highlighter.page)()
		} as annotationStub;
	};

	/**
	 * If the user has edit access to the project and the bookmark does not exist already,
	 * creates a "bookmark" annotation for the current page, and adds it to the special
	 * "bookmarks" topic in the current project's outline.
	 */
	bookmark = async (): Promise<annotationUuid> => {
		await Highlighter.beforeFirstDataInteraction();

		if (!Data.app.project)
			throw new Error();

		if (Data.app.bookmarkUuid)
			return Data.app.bookmarkUuid;

		const stub = this.generateBookmarkStub();
		const annotation = await Data.annotation.create(stub, Data.app.project.uuid);

		toast({
			content: "Bookmark added",
			id:      "bookmark-added"
		});

		return annotation.uuid;
	};

	/**
	 * Removes bookmark annotation for the current page in the current project's outline.
	 */
	unbookmark = async () => {
		if (!Data.app.project)
			throw new Error();

		if (!Data.app.bookmarkUuid)
			return;

		await Data.annotation.delete(Data.app.bookmarkUuid, Data.app.project.uuid);
	};
}

export default new Bookmark();
